import { render, staticRenderFns } from "./BroadcastList.vue?vue&type=template&id=0748225f&scoped=true&"
import script from "./BroadcastList.vue?vue&type=script&lang=js&"
export * from "./BroadcastList.vue?vue&type=script&lang=js&"
import style0 from "./BroadcastList.vue?vue&type=style&index=0&id=0748225f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0748225f",
  null
  
)

export default component.exports